document.addEventListener('DOMContentLoaded', function() {
    // Funzione per calcolare la distanza tra due tocchi
    function getDistance(touch1, touch2) {
        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    // Funzione per creare e gestire l'overlay di zoom
    function createZoomOverlay(image) {
        const overlay = document.createElement('div');
        overlay.className = 'custom-zoom-overlay';
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'rgba(0,0,0,0)';
        overlay.style.zIndex = '1000';
        overlay.style.display = 'flex';
        overlay.style.alignItems = 'center';
        overlay.style.justifyContent = 'center';
        overlay.style.transition = 'background-color 0.3s ease';
        overlay.style.touchAction = 'none'; // Blocca tutti gli eventi touch nativi sull'overlay

        const zoomedImage = document.createElement('img');
        zoomedImage.src = image.src;
        zoomedImage.style.maxWidth = '100%';
        zoomedImage.style.maxHeight = '100%';
        zoomedImage.style.objectFit = 'contain';
        zoomedImage.style.transform = 'scale(1)';
        zoomedImage.style.transformOrigin = 'center center';
        zoomedImage.style.transition = 'transform 0.2s ease-out';
        zoomedImage.style.willChange = 'transform';

        overlay.appendChild(zoomedImage);
        document.body.appendChild(overlay);

        return { overlay, zoomedImage };
    }

    // Funzione per chiudere l'overlay con animazione
    function closeOverlay(overlay, zoomedImage) {
        if (!overlay || !zoomedImage) return;
        overlay.style.backgroundColor = 'rgba(0,0,0,0)';
        zoomedImage.style.transform = 'scale(1)';
        setTimeout(() => {
            if (overlay && overlay.parentNode) {
                document.body.removeChild(overlay);
            }
            // Ripristina il meta viewport
            restoreViewport();
        }, 300);
    }

    // Funzione per bloccare lo zoom del viewport
    function lockViewport() {
        let viewportMeta = document.querySelector('meta[name="viewport"]');
        if (!viewportMeta) {
            viewportMeta = document.createElement('meta');
            viewportMeta.name = 'viewport';
            document.head.appendChild(viewportMeta);
        }
        // Salva il contenuto originale
        viewportMeta.dataset.originalContent = viewportMeta.content;
        // Blocca lo zoom
        viewportMeta.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';
        console.log('Viewport bloccato per evitare zoom della pagina');
    }

    // Funzione per ripristinare il viewport
    function restoreViewport() {
        const viewportMeta = document.querySelector('meta[name="viewport"]');
        if (viewportMeta && viewportMeta.dataset.originalContent) {
            viewportMeta.content = viewportMeta.dataset.originalContent;
            console.log('Viewport ripristinato');
        }
    }

    // Funzione per inizializzare il pinch-zoom su un'immagine
    function initializePinchZoom(container, image) {
        if (container.dataset.pinchInitialized) return;
        container.dataset.pinchInitialized = 'true';

        let initialDistance = 0;
        let currentScale = 1;
        let isZooming = false;
        let overlay = null;
        let zoomedImage = null;
        let translateX = 0;
        let translateY = 0;
        let lastTouchX = 0;
        let lastTouchY = 0;
        let lastTapTime = 0;

        // Gestione pizzico
        container.addEventListener('touchstart', function(e) {
            if (e.touches.length === 2) {
                e.preventDefault();
                e.stopPropagation();
                initialDistance = getDistance(e.touches[0], e.touches[1]);
                isZooming = true;
                lockViewport(); // Blocca il viewport

                if (!overlay) {
                    const zoomElements = createZoomOverlay(image);
                    overlay = zoomElements.overlay;
                    zoomedImage = zoomElements.zoomedImage;
                    overlay.style.backgroundColor = 'rgba(0,0,0,0.8)';
                    console.log('Overlay di zoom creato per immagine:', image.src);

                    // Chiudi l'overlay con un tap sullo sfondo
                    overlay.addEventListener('touchstart', function(e) {
                        if (e.target === overlay) {
                            e.preventDefault();
                            e.stopPropagation();
                            closeOverlay(overlay, zoomedImage);
                            overlay = null;
                            zoomedImage = null;
                            currentScale = 1;
                            translateX = 0;
                            translateY = 0;
                            isZooming = false;
                            console.log('Overlay chiuso con tap sullo sfondo');
                        }
                    }, { passive: false });
                }
            } else if (e.touches.length === 1 && isZooming) {
                lastTouchX = e.touches[0].clientX;
                lastTouchY = e.touches[0].clientY;
            }
        }, { passive: false });

        container.addEventListener('touchmove', function(e) {
            if (e.touches.length === 2 && isZooming && overlay) {
                e.preventDefault();
                e.stopPropagation();
                const currentDistance = getDistance(e.touches[0], e.touches[1]);
                const scaleChange = currentDistance / initialDistance;
                currentScale = Math.min(Math.max(0.5, scaleChange), 4); // Permetti scale fino a 0.5x per debug

                zoomedImage.style.transform = `scale(${currentScale}) translate(${translateX}px, ${translateY}px)`;
                console.log('Pizzico in corso, scala:', currentScale, 'distanza:', currentDistance);
            } else if (e.touches.length === 1 && isZooming && currentScale > 1) {
                e.preventDefault();
                e.stopPropagation();
                const deltaX = e.touches[0].clientX - lastTouchX;
                const deltaY = e.touches[0].clientY - lastTouchY;
                translateX += deltaX / currentScale;
                translateY += deltaY / currentScale;
                lastTouchX = e.touches[0].clientX;
                lastTouchY = e.touches[0].clientY;

                zoomedImage.style.transform = `scale(${currentScale}) translate(${translateX}px, ${translateY}px)`;
            }
        }, { passive: false });

        container.addEventListener('touchend', function(e) {
            if (isZooming && e.touches.length < 2) {
                e.preventDefault();
                e.stopPropagation();
                if (currentScale <= 1.2) {
                    closeOverlay(overlay, zoomedImage);
                    overlay = null;
                    zoomedImage = null;
                    currentScale = 1;
                    translateX = 0;
                    translateY = 0;
                    isZooming = false;
                    console.log('Overlay chiuso, scala minima raggiunta:', currentScale);
                }
                initialDistance = 0;
            }
        }, { passive: false });

        // Doppio tap per zoom rapido
        container.addEventListener('touchstart', function(e) {
            if (e.touches.length === 1) {
                const currentTime = new Date().getTime();
                if (currentTime - lastTapTime < 300) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!isZooming) {
                        const zoomElements = createZoomOverlay(image);
                        overlay = zoomElements.overlay;
                        zoomedImage = zoomElements.zoomedImage;
                        overlay.style.backgroundColor = 'rgba(0,0,0,0.8)';
                        currentScale = 2;
                        zoomedImage.style.transform = `scale(${currentScale})`;
                        lockViewport();

                        overlay.addEventListener('touchstart', function(e) {
                            if (e.target === overlay) {
                                e.preventDefault();
                                e.stopPropagation();
                                closeOverlay(overlay, zoomedImage);
                                overlay = null;
                                zoomedImage = null;
                                currentScale = 1;
                                translateX = 0;
                                translateY = 0;
                                isZooming = false;
                                console.log('Overlay chiuso con tap sullo sfondo');
                            }
                        }, { passive: false });

                        isZooming = true;
                        console.log('Doppio tap: zoom attivato a 2x');
                    } else {
                        closeOverlay(overlay, zoomedImage);
                        overlay = null;
                        zoomedImage = null;
                        currentScale = 1;
                        translateX = 0;
                        translateY = 0;
                        isZooming = false;
                        console.log('Doppio tap: zoom disattivato');
                    }
                }
                lastTapTime = currentTime;
            }
        }, { passive: false });
    }

    // Inizializzazione immagini
    function setupPinchZoom() {
        const mediaContainers = document.querySelectorAll('.m-product-media--slider .m-product-media');
        console.log('Contenitori trovati:', mediaContainers.length);

        if (mediaContainers.length === 0) {
            console.error('Nessun contenitore trovato con il selettore .m-product-media--slider .m-product-media');
            return;
        }

        mediaContainers.forEach((container, index) => {
            const image = container.querySelector('.m-image img');
            if (image) {
                console.log('Immagine trovata nel contenitore', index, ':', image.src);
                if ('ontouchstart' in window) {
                    initializePinchZoom(container, image);
                }
            } else {
                console.warn('Nessuna immagine trovata nel contenitore', index);
            }
        });
    }

    if ('ontouchstart' in window) {
        setupPinchZoom();
        setTimeout(setupPinchZoom, 1000);
    }

    // Osserva il carosello per cambi slide
    const swiperWrapper = document.querySelector('.m-product-media--slider .swiper-wrapper');
    if (swiperWrapper) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'style' || mutation.type === 'childList') {
                    console.log('Cambio slide rilevato, reinizializzazione pinch-zoom');
                    setupPinchZoom();
                }
            });
        });
        observer.observe(swiperWrapper, { attributes: true, childList: true, subtree: true });
    }
});

// CSS per scroll verticale e overlay
const style = document.createElement('style');
style.innerHTML = `
    .m-product-media--slider .swiper-slide {
        touch-action: pan-y pinch-zoom !important;
    }
    .custom-zoom-overlay {
        touch-action: none;
    }
`;
document.head.appendChild(style);